import { render, staticRenderFns } from "./FilesList.vue?vue&type=template&id=8f424048&"
import script from "./FilesList.vue?vue&type=script&lang=js&"
export * from "./FilesList.vue?vue&type=script&lang=js&"
import style0 from "./FilesList.vue?vue&type=style&index=0&id=8f424048&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports